import React from 'react';
import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';

const QuickActions = ({ onInviteMember, onCreateClass, onCreateEvent, onViewReports, onManageSettings, onCreateMember, onCreateStaff }) => {
  const navigate = useNavigate();
  
  // ... Add handler functions ... //
  const handleInviteMember = () => {
    if (onInviteMember) onInviteMember();
  };

  const handleCreateClass = () => {
    if (onCreateClass) onCreateClass();
  };

  const handleCreateEvent = () => {
    if (onCreateEvent) onCreateEvent();
  };

  const handleSendAnnouncement = () => {
    // Placeholder for send announcement functionality
    console.log('Send announcement clicked');
  };

  const handleViewReports = () => {
    if (onViewReports) onViewReports();
  };

  const actions = [
    {
      icon: 'UserPlus',
      iconColor: 'var(--color-primary)',
      title: 'Create Member',
      description: 'Register new gym member',
      onClick: onCreateMember
    },
    {
      icon: 'Briefcase',
      iconColor: 'var(--color-success)',
      title: 'Create Staff',
      description: 'Add staff or trainer account',
      onClick: onCreateStaff
    },
    {
      icon: 'Calendar',
      iconColor: 'var(--color-accent)',
      title: 'Create Class',
      description: 'Schedule a new fitness class',
      onClick: onCreateClass
    },
    {
      icon: 'CalendarDays',
      iconColor: 'var(--color-warning)',
      title: 'Create Event',
      description: 'Organize a gym event',
      onClick: onCreateEvent
    },
    {
      icon: 'BarChart',
      iconColor: 'var(--color-error)',
      title: 'View Reports',
      description: 'Analytics and insights',
      onClick: onViewReports
    }
  ];

  const quickActions = [
    {
      title: 'Invite Member',
      description: 'Send invitation to new member',
      icon: 'UserPlus',
      color: 'bg-blue-500',
      onClick: handleInviteMember
    },
    {
      title: 'Create Class',
      description: 'Schedule a new fitness class',
      icon: 'Calendar',
      color: 'bg-green-500',
      onClick: handleCreateClass
    },
    {
      title: 'Create Event',
      description: 'Add a new gym event',
      icon: 'CalendarPlus',
      color: 'bg-purple-500',
      onClick: handleCreateEvent
    },
    {
      title: 'Gym Settings',
      description: 'Customize logo and branding',
      icon: 'Settings',
      color: 'bg-orange-500',
      onClick: () => navigate('/gym-settings')
    },
    {
      title: 'Send Announcement',
      description: 'Broadcast message to members',
      icon: 'Megaphone',
      color: 'bg-red-500',
      onClick: handleSendAnnouncement
    },
    {
      title: 'View Reports',
      description: 'Analytics and insights',
      icon: 'BarChart3',
      color: 'bg-indigo-500',
      onClick: handleViewReports
    }
  ];

  return (
    <div className="mb-6 md:mb-8">
      <h2 className="text-lg font-heading font-semibold text-foreground mb-4">Quick Actions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {actions?.map((action, index) => (
          <button
            key={index}
            onClick={action?.onClick}
            className="bg-card rounded-xl shadow-md p-6 hover-lift transition-smooth text-left group"
          >
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 group-hover:bg-primary/20 transition-smooth">
                <Icon name={action?.icon} size={24} color={action?.iconColor} strokeWidth={2} />
              </div>
              <div className="flex-1">
                <p className="font-semibold text-foreground mb-1">{action?.title}</p>
                <p className="text-sm text-muted-foreground">{action?.description}</p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;